module.exports = "/_next/static/images/dhaiwat-388b25d342d756fa260bbe17963b19a2.png";